export default "__VITE_ASSET__1hWll2bM__"